import type { RechercheQueryProformaDTO } from '@/features/api/extranet/dto/Demande/Recherche/Proforma/RechercheQueryProFormaDTO'
import { buildRechercheStore } from '../storeRechercheBuilder'
import type { RechercheResultProformaDTO } from '@/features/api/extranet/dto/Demande/Recherche/Proforma/RechercheResultProformaDTO'

export const API_PATH_PROFORMA = '/proforma/demandes'

export const useRechercheProformaStore = buildRechercheStore<RechercheQueryProformaDTO, RechercheResultProformaDTO>({
  storeName: 'rechercheProformaStore',
  apiPath: API_PATH_PROFORMA,
})
